import { imageUrl } from '@helpers/image';
import { useScrollPeek } from '@hooks/useScrollPeek';
import { ReactComponent as SvgClose } from '@img/icons/close.svg';
import { ReactComponent as SvgSearch } from '@img/icons/search.svg';
import { ReactComponent as SvgUser } from '@img/icons/user.svg';
import MessageBanner from '@stories/Components/MessageBanner/MessageBanner';
import MobileFloatingCta from '@stories/Components/MobileFloatingCta/MobileFloatingCta';
import NavigationDesktop from '@stories/Components/NavigationDesktop/NavigationDesktop';
import NavigationMobile from '@stories/Components/NavigationMobile/NavigationMobile';
import SearchDropdown from '@stories/Components/SearchDropdown/SearchDropdown';
import { Divide as Hamburger } from 'hamburger-react';
import * as React from 'react';
import S from './Header.styles';
const Header = (props) => {
    const [isSearchActive, setIsSearchActive] = React.useState(false);
    const [isMobileNavActive, setIsMobileNavActive] = React.useState(false);
    const isPeeking = useScrollPeek({ threshold: 100 });
    const [isScrollActive, setIsScrollActive] = React.useState(false);
    React.useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY >= 100) {
                setIsScrollActive(true);
            }
            else {
                setIsScrollActive(false);
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(S.GlobalStyles, null),
        React.createElement(S.Container, { "data-reduce": !isPeeking, "data-scroll-active": isScrollActive },
            props.messageBanner && React.createElement(MessageBanner, { ...props.messageBanner }),
            React.createElement(S.TopContainer, null,
                React.createElement(S.TopInner, null,
                    React.createElement(S.QuickLinkList, null,
                        React.createElement(S.QuickLinkItem, null,
                            React.createElement(S.QuickLinkAnchor, { "data-search-active": isSearchActive, as: "button", onClick: (event) => {
                                    event.preventDefault();
                                    toggleSearch();
                                } },
                                React.createElement(S.QuickLinkIcon, { as: isSearchActive ? SvgClose : SvgSearch }),
                                "Search"))),
                    React.createElement(S.MobileSearch, { "aria-label": "Toggle Search", onClick: (event) => {
                            event.preventDefault();
                            toggleSearch();
                        } },
                        React.createElement(S.MobileSearchIcon, { as: isSearchActive ? SvgClose : SvgSearch })),
                    React.createElement("a", { href: "/", "aria-label": "Homepage" },
                        React.createElement(S.Logo, { alt: props.logo.altText, loading: "eager", src: imageUrl(props.logo, { width: 308 }) })),
                    React.createElement(S.MobileNav, { "aria-label": "Toggle Navigation", onClick: (event) => {
                            event.preventDefault();
                            toggleMobileNav();
                        } },
                        React.createElement(Hamburger, { color: "currentColor", size: 25, toggled: isMobileNavActive })),
                    React.createElement(S.QuickLinkList, null,
                        props.contactLink && (React.createElement(S.QuickLinkItem, null,
                            React.createElement(S.QuickLinkAnchor, { href: props.contactLink.url, target: props.contactLink.target, title: props.contactLink.text },
                                React.createElement("span", null, props.contactLink.text)))),
                        props.authUrl && (React.createElement(S.QuickLinkItem, null,
                            React.createElement(S.QuickLinkAnchor, { href: props.authUrl },
                                React.createElement(S.QuickLinkIcon, { as: SvgUser }),
                                props.isAuthenticated ? 'My Account' : 'Log In')))))),
            React.createElement(S.NavigationContainer, null,
                React.createElement(NavigationDesktop, { items: props.navigation })),
            props.ctas && (React.createElement(S.CtaContainer, { style: { '--count': props.ctas.length } }, props.ctas.map((cta) => (React.createElement(S.Cta, { key: cta.id, href: cta.url, target: cta.target }, cta.text))))),
            isSearchActive && (React.createElement(SearchDropdown, { placeholder: props.searchPlaceholder, searchResultsUrl: props.searchResultsUrl, onClose: () => {
                    toggleSearch();
                } }))),
        React.createElement(NavigationMobile, { authUrl: props.authUrl, isAccountArea: false, isActive: isMobileNavActive, isAuthenticated: props.isAuthenticated, items: props.navigation, scrollActive: isScrollActive, contactLink: props.contactLink, locationLink: props.locationLink }),
        props.floatingCta && props.floatingCta.length > 0 && (React.createElement(S.FloatingCtaContainer, null, props.floatingCta.map((cta) => (React.createElement(MobileFloatingCta, { key: cta.url, ...cta })))))));
    function toggleSearch() {
        setIsMobileNavActive(false);
        setIsSearchActive(!isSearchActive);
    }
    function toggleMobileNav() {
        setIsMobileNavActive(!isMobileNavActive);
        setIsSearchActive(false);
    }
};
export default Header;
